// The client fills a 100 ml bottle: a perfume can never be larger.
// No import: also used by the training script of the ingredient suggestion (plain Node).
export const PERFUME_BOTTLE_VOLUME = 100;

// ml left in the bottle (never negative)
export function bottleVolumeLeft(perfumeVolume: number): number {
  return Math.max(0, PERFUME_BOTTLE_VOLUME - perfumeVolume);
}
